<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-14 10:21:19
-->
<script>
import { BlockStore } from "./store";
import _ from "lodash";
import { KeySubscriber, ShortCutKeyDescritpion } from "./index";

function noop() {}

export default {
  name: "VERibbonPanel",
  props: {
    name: {
      type: String,
      required: true,
    },
    label: String,
    shortcut: Object,
  },
  provide() {
    return {
      keySubscriber: this.keySubscriber,
    };
  },
  data() {
    this._store = new BlockStore();
    return {
      keySubscriber: new KeySubscriber(),
      visibleBlocks: [],
      hiddenBlocks: [],
    };
  },
  methods: {
    addBlock(block) {
      const pos = this.$slots.default.$$index((comp) => {
        return (
          ((comp.componentOptions || {}).propsData || {}).label == block.label
        );
      });
      this._store.commit("insertBlock", { block, pos });
      if (this._hasInitialized) {
        this._hasSplited = false;
        this.doSplit(true);
      }
    },
    removeBlock(block) {
      this._store.commit("removeBlock", block);
      if (this._hasInitialized) {
        this._hasSplited = false;
        this.doSplit(true);
      }
    },

    updateBlockWidth() {
      if (!this.isActive) return;
      this._hasUpdateBlockWidth = true;
      const el = this.$el;
      if (!el) return;
      const blocks = this.$el.querySelectorAll(
        ".component--ribbon__panel-block"
      );
      for (let i = 0; i < blocks.length; i++) {
        this._store.commit("updateWidth", {
          index: i,
          value: blocks[i].clientWidth,
        });
      }
    },
    splitBlocksInTwoCollection(forceUpdate) {
      if (!this.isActive || this._isSpliting || this._hasSplited) return;
      this._isSpliting = true;
      const root = this.$el;
      if (!root) return;

      const maxWidth = root.childNodes[1].clientWidth - 40;
      let visibleBlocks = [],
        unVisibleBlocks = [];
      const blocks = this._store.states.blocks;
      let pos = 0,
        costWidth = 0;
      while (pos < blocks.length) {
        if (costWidth + blocks[pos].width > maxWidth) {
          break;
        }
        visibleBlocks.push(blocks[pos]);
        costWidth += blocks[pos].width;
        pos++;
      }
      for (let i = pos; i < blocks.length; i++) {
        unVisibleBlocks.push(blocks[i]);
      }

      if (
        !!forceUpdate ||
        visibleBlocks.length != this.visibleBlocks.length ||
        unVisibleBlocks.length != this.hiddenBlocks.length
      ) {
        this.visibleBlocks = visibleBlocks;
        this.hiddenBlocks = unVisibleBlocks;
        this.$forceUpdate();
      }
      this._hasSplited = true;
      this.$nextTick(() => {
        this._isSpliting = false;
      });
    },
    doSplit(forceUpdate) {
      this.updateBlockWidth();
      this.splitBlocksInTwoCollection(forceUpdate);
    },

    handleWindowResize() {
      if (!this.isActive) return;
      this._hasSplited = false;
      this.doSplit();
    },

    initShortcuts() {
      if (!this.shortcut || !this.keySubscriber) return;
      for (const key in this.shortcut) {
        try {
          const newShortcutDescription = ShortCutKeyDescritpion.parse(key);
          const defineBody = this.shortcut[key];
          if (!!defineBody.trigger)
            defineBody.triggerMoment = defineBody.trigger;
          this.keySubscriber.subscribe(
            newShortcutDescription,
            defineBody.handler || noop
          );
        } catch (err) {
          console.warn(
            `Valid format for panel's shortcut.For example:{'Ctrl+Enter':function(){}}`
          );
        }
      }
    },
  },
  computed: {
    isActive() {
      return this.$parent.currentPanel === this.name;
    },
  },
  render(h) {
    if (this._hasUpdateBlockWidth) {
      return h(
        "div",
        {
          class: [
            "component--ribbon__panel one",
            this.isActive ? "active" : null,
          ],
        },
        [
          h("div", { class: "visible-none" }, this.$slots.default),
          h(
            "div",
            { class: "ribbon-panel__inner visible", ref: "inner" },
            this.visibleBlocks.map((b) =>
              //b.render.call(this._renderProxy, h, "normal", null)
              b.render(h, "normal", null)
            )
          ),
          h(
            "div",
            {
              class: "ribbon-panel__more",
              style: {
                display: this.hiddenBlocks.length > 0 ? "block" : "none",
              },
            },
            [
              h(
                "el-popover",
                {
                  props: {
                    trigger: "click",
                    placement: "bottom-end",
                  },
                },
                [
                  h(
                    "div",
                    {
                      class: "flex-row",
                    },
                    this.hiddenBlocks.map((b) =>
                      b.render.call(this._renderProxy, h, "normal", null)
                    )
                  ),
                  h("fa-icon", {
                    props: {
                      icon: "ellipsis-h",
                    },
                    style: {
                      fontSize: "20px",
                      lineHeight: "22px",
                    },
                    slot: "reference",
                  }),
                ]
              ),
            ]
          ),
        ]
      );
    } else {
      return h(
        "div",
        {
          class: [
            "component--ribbon__panel two",
            this.isActive ? "active" : null,
          ],
        },
        [
          h("div", { class: "visible-hidden" }, this.$slots.default),
          h(
            "div",
            { class: "ribbon-panel__inner visible", ref: "inner" },
            this._store.states.blocks.map((b) => b.render(h, "normal", null))
          ),
        ]
      );
    }
  },
  watch: {
    isActive(newValue) {
      this.$nextTick(() => {
        this.doSplit();
      });
    },
  },
  created() {
    this.$on("block-update", () => {
      this.splitBlocksInTwoCollection(true);
    });
    this.initShortcuts();
    this.keySubscriber.start();
  },
  updated() {
    this.$nextTick(() => {
      //this.doSplit();
    });
  },
  mounted() {
    this.doSplit();
    this._hasInitialized = true;
    this._resizeHandle = _.throttle((ev) => {
      this.handleWindowResize();
    }, 10);
    window.addEventListener("resize", this._resizeHandle);
  },
  destroyed() {
    window.removeEventListener("resize", this._resizeHandle);
    this.keySubscriber.shutdown();
  },
};
</script>

<style lang="scss">
.component--ribbon__panel {
  width: 100%;
  height: 100%;
  overflow-x: unset;
  overflow-y: unset;
  display: none;
  padding: 4px 0 4px 0px;
  &.active {
    display: block;
  }

  .ribbon-panel__inner {
    height: 100%;
    display: flex;
    flex-direction: row;
  }

  .ribbon-panel__more {
    position: absolute;
    right: 3px;
    top: 6px;
    color: gray;
    cursor: pointer;
  }
}

.component--ribbon__panel-block {
  border-right: 1px solid #e1e1e1;
  padding: 4px;
}
</style>